// extracted by mini-css-extract-plugin
export var heading = "PricingCardCategory-module--heading--02425";
export var items = "PricingCardCategory-module--items--bc048";
export var section = "PricingCardCategory-module--section--87f7e";